// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.narrativa-scroll .depurador{position:sticky;width:100%;border-top:2px solid crimson;z-index:10;height:2px}section.narrativa-scroll div.contenedor-portada{position:sticky;height:100vh;top:0}section.narrativa-scroll article{position:relative;top:-100vh}section.narrativa-scroll article .bullet{height:100vh;position:relative;display:flex}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
